export default {
  // Default variants
  default: "w-10 h-10 bg-admin_neutral_3/80 rounded-full flex items-center justify-center flex-shrink-0",
  
  // Admin variants  
  admin_small: "w-8 h-8 bg-admin_neutral_3/80 rounded-full flex items-center justify-center flex-shrink-0",
  admin_medium: "w-10 h-10 bg-admin_neutral_3/80 rounded-full flex items-center justify-center flex-shrink-0",
  admin_large: "w-12 h-12 bg-admin_neutral_3/80 rounded-full flex items-center justify-center flex-shrink-0",
  admin_xl: "w-16 h-16 bg-admin_neutral_3/80 rounded-full flex items-center justify-center flex-shrink-0",
  
  // Admin list variants (for tables and lists)
  admin_list: "w-10 h-10 bg-admin_neutral_3/80 rounded-full flex items-center justify-center flex-shrink-0",
  admin_list_small: "w-8 h-8 bg-admin_neutral_3/80 rounded-full flex items-center justify-center flex-shrink-0",
  
  // Admin dropdown variants
  admin_dropdown: "w-8 h-8 bg-admin_neutral_3/80 rounded-full flex items-center justify-center flex-shrink-0",
  admin_dropdown_large: "w-10 h-10 bg-admin_neutral_3/80 rounded-full flex items-center justify-center flex-shrink-0",
  
  // Admin modal variants
  admin_modal: "w-12 h-12 bg-admin_neutral_3/80 rounded-full flex items-center justify-center flex-shrink-0",
  admin_modal_large: "w-16 h-16 bg-admin_neutral_3/80 rounded-full flex items-center justify-center flex-shrink-0",
  
  // Admin colored variants
  admin_success: "w-10 h-10 bg-admin_success rounded-full flex items-center justify-center flex-shrink-0",
  admin_warning: "w-10 h-10 bg-admin_warning rounded-full flex items-center justify-center flex-shrink-0",
  admin_error: "w-10 h-10 bg-admin_error rounded-full flex items-center justify-center flex-shrink-0",
  admin_info: "w-10 h-10 bg-admin_info_bg rounded-full flex items-center justify-center flex-shrink-0",
  
  // Admin bordered variants
  admin_bordered: "w-10 h-10 bg-admin_neutral_3/80 border-2 border-admin_neutral_1 rounded-full flex items-center justify-center flex-shrink-0",
  admin_bordered_white: "w-10 h-10 bg-admin_neutral_3/80 border-2 border-white rounded-full flex items-center justify-center flex-shrink-0",
  
  // Admin square variants (for special use cases)
  admin_square: "w-10 h-10 bg-admin_neutral_3/80 rounded-lg flex items-center justify-center flex-shrink-0",
  admin_square_small: "w-8 h-8 bg-admin_neutral_3/80 rounded-lg flex items-center justify-center flex-shrink-0",
  admin_square_large: "w-12 h-12 bg-admin_neutral_3/80 rounded-lg flex items-center justify-center flex-shrink-0",
}